import { withNamespaces } from 'react-i18next';

import { BidVerificationStepStates } from '../constants';

const VerificationStepper = ({
    steps = [],
    t,
}) => {
    return (
        <div className="bid-verification-progress mb-3">
            {steps.map(({ stage, state }, index) => {
                const stateInfos = BidVerificationStepStates[state];
                const nextState = steps[index + 1]?.state;
                const connectorClass = nextState
                    ? BidVerificationStepStates[state]?.connector
                    : '';

                return (
                    <div
                        className={`bid-verification-stage ${connectorClass}`}
                        key={stage}
                    >
                        <i className={`stage-icon ${stateInfos.icon} ${stateInfos.className}`} />
                        <span className="stage-title">{t(stage)}</span>
                        <small className={`${stateInfos.className} fw-bold`}>{t(stateInfos.title)}</small>
                    </div>
                );
            })}
        </div>
    );
};

export default withNamespaces()(
    VerificationStepper
);
